import * as React from 'react';

import { Link, useLocation, NavLink } from 'react-router-dom';

import Card from 'antd/lib/card';

import { getSearchParamsFromUrl } from '@common/react/utils/FIltersParamsFromUrl/FiltersParamsFromUrl';

import { Doctor } from '@app/objects/Doctor';
import DoctorBookedTimeBlock from '@app/components/UI/DoctorBookedTimeBlock/DoctorBookedTimeBlock';
import { Location } from '@app/objects/Location';
import SpecialtyTag from '@app/components/Pages/Specialties/SpecialtyTag';
import DoctorAvatar from '@app/components/UI/DoctorCard/DoctorAvatar';
import Stars from '@app/components/UI/Stars/Stars';

interface IProp {
	goToPath: (path: string, state) => void;
	from?: number;
	daysRange?: number;
	withoutBookedTime?: boolean;
}

const DoctorCard: React.FC<Doctor & IProp> = (props) => {
	const {
		nameEn,
		specialties,
		locations,
		avatar,
		portalPathEn,
		id,
		averageReviewRate,
		totalReviewCount,
		portalShortText,
		// languages,
		doctorBookedTimes,
		from,
		daysRange,
		goToPath,
		withoutBookedTime,
		scheduleAppointment,
	} = props;

	const location = useLocation();

	const [selectedTime, setSelectedTime] = React.useState<number | undefined>();
	const [selectedLocation, setSelectedLocation] = React.useState<Location | undefined>(
		locations.find(({ locationId }) => locationId === getSearchParamsFromUrl(location)?.locationId)?.location
					|| locations?.[0]?.location,
	);
	const [width, setWidth] = React.useState('calc(100% - 671px)');

	React.useEffect(() => {
		if (selectedLocation?.id && selectedTime) {
			goToPath(`/doctor/${portalPathEn}`, { selectedLocation, scheduledTime: selectedTime });
		}
	}, [selectedTime, selectedLocation]);

	React.useEffect(() => {
		setWidth(`calc(100% - ${(daysRange || 0) * 88 + 55}px)`);
	}, [daysRange]);

	const columnsCount = Object.keys(doctorBookedTimes?.values || {});

	const title = React.useMemo(() => <>
		<div className="row">
			<div className={withoutBookedTime ? 'col-sm-12' : 'col-sm-4'}>
				<div className="card-title">
					<h3 className="mt10">{portalPathEn ? <Link to={`/doctor/${portalPathEn}`}>{nameEn}</Link> : nameEn}</h3>
				</div>
				<div>
					<div className="doctor-rate mb10">
						<strong className="mr10">
							<Stars value={averageReviewRate || 0} />
						</strong>
						(
						{totalReviewCount}
						)
					</div>
					{withoutBookedTime && locations && locations.length > 0 && <div
						className="mb10"
					>
						{locations.map(({ location }) => <span
							className="inline-select-item inline-select-item_sm"
							key={location.id}
							title={location.nameEn ? `${location.nameEn} ${location.addressEn || ''}` : ''}
						>
							{location.nameEn ? `${location.nameEn} ${location.addressEn || ''}` : ''}
						</span>)}
					</div>}
					{specialties && specialties.length > 0
						&& <h6 className="mb10 doctor-card-label">
							{specialties.map((s) => s.specialty && (
								<SpecialtyTag specialty={s.specialty} key={s.id} />
							))}
						</h6>}
					{portalShortText
						? <div className="ant-card-meta-description mb10">{portalShortText}</div> : null
					}
					{/* languages && languages.length > 0 &&
						<h6 className="mb10">Languages: {languages.map(l => l.language.name).join(', ')}</h6> */}
				</div>
			</div>
			{!withoutBookedTime && <div className="col-sm-8 doctor-times">
				<div className="doctor-card-table">
					<div
						className="doctor-card-locations"
						style={{
							width,
						}}
					>
						{locations && locations.length > 0
							&& locations.map(({ location }) => (
								<button
									type="button"
									className="inline-select-item inline-select-item_sm btn-primary"
									key={location.id}
									title={location.nameEn ? `${location.nameEn} ${location.addressEn || ''}` : ''}
									onClick={() => setSelectedLocation(location)}
								>
									{location.nameEn ? `${location.nameEn} ${location.addressEn || ''}` : ''}
								</button>
							))
						}
					</div>
					{!withoutBookedTime && doctorBookedTimes && scheduleAppointment && locations && locations.length > 0
						&& <DoctorBookedTimeBlock
							key={`${from} ${daysRange} ${columnsCount}`}
							value={doctorBookedTimes}
							doctorId={id}
							locations={locations.map((location) => location.location)}
							rowCount={5}
							days={daysRange}
							onSelect={(time, location, asNearestDate) => {
								goToPath(`/doctor/${portalPathEn}${asNearestDate
									? `?from=${time}` : ''}`, { selectedLocation: location, scheduledTime: time, asNearestDate });
							}}
							nearestDateRedirect
							className="text-center"
							withoutLocationButtons
							selectLocationById={selectedLocation?.id}
						/>}
					{!scheduleAppointment && <div
						style={{
							flexGrow: 1,
						}}
						className="text-center"
					>
						<button
							type="button"
							className="btn btn-default nearest-btn"
							onClick={() => {
								goToPath(`/doctor/${portalPathEn}`, { selectedLocationId: selectedLocation?.id });
							}}
						>
							Send Inquiry
						</button>
					</div>}
				</div>
			</div>}
		</div>
	</>, [nameEn, specialties, locations, portalPathEn, /* languages, */ doctorBookedTimes, selectedTime, selectedLocation, width]);

	return (
		<div className="doctor-card">
			<Card style={{ width: '100%' }}>
				<Card.Meta
					avatar={<DoctorAvatar
						alt={nameEn}
						src={avatar}
						path={portalPathEn}
					/>}
					title={title}
				/>
			</Card>
		</div>
	);
};

export default DoctorCard;
